import { Box, Grid, Typography } from '@material-ui/core'
import * as Sentry from '@sentry/react'
import axios from 'axios'
import { validate } from 'email-validator'
import { FormEvent, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

import Button from '@/components/button'
import Card from '@/components/card'
import InputText from '@/components/input-text'
import { env } from '@/config/env'
import { useAuth } from '@/hooks/use-auth'
import { defaultRoute, routes } from '@/routes/config'

import { useStyles } from './styles'

export default function Login() {
  const classes = useStyles()
  const navigate = useNavigate()
  const { signIn } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [isLoadingLogin, setIsLoadingLogin] = useState(false)
  const [isValidEmail, setIsValidEmail] = useState({ valid: true, message: '' })
  const [isValidPassword, setIsValidPassword] = useState({
    valid: true,
    message: '',
  })

  function verifyCredentials() {
    let emailValidate = { valid: true, message: '' }
    let passwordValidate = { valid: true, message: '' }

    if (!email.trim())
      emailValidate = { valid: false, message: 'E-mail é obrigatório' }
    else if (!validate(email))
      emailValidate = { valid: false, message: 'Formato de email inválido' }

    if (!password.trim())
      passwordValidate = { valid: false, message: 'Senha é obrigatória' }

    setIsValidEmail(emailValidate)
    setIsValidPassword(passwordValidate)

    return emailValidate.valid && passwordValidate.valid
  }

  async function submitLogin(e: FormEvent) {
    e.preventDefault()

    if (verifyCredentials()) {
      setIsLoadingLogin(true)

      signIn({ email, password })
        .then(() => {
          navigate(defaultRoute())
        })
        .catch((e) => {
          setIsLoadingLogin(false)
          setEmail('')
          setPassword('')

          if (axios.isAxiosError(e)) {
            const possibleStatus = [403, 404, 400]
            const status = e.response?.status

            if (status && possibleStatus.includes(status))
              return toast('Email e/ou senha inválidos', { type: 'error' })
          }

          toast('Houve um problema, tente mais tarde', { type: 'error' })
          Sentry.captureException(e, {
            user: { email },
          })
        })
    }
  }

  return (
    <Grid container className={classes.main}>
      <Box zIndex={100}>
        <Typography variant='h1'>
          Desenvolvido por <img src='assets/img/new-cromai-logo.svg' alt='' />
        </Typography>
      </Box>

      <Card className={classes.cardContent}>
        <Box display='flex'>
          <img src='assets/img/new-atlas-logo.svg' alt='Logo do Cromai Atlas' />
          <Typography variant='h1'>Cromai Atlas</Typography>
        </Box>
        <Typography variant='subtitle1'>
          Faça login com sua conta cromai.
        </Typography>
        <form onSubmit={submitLogin} noValidate>
          <InputText
            id='email'
            label='E-mail'
            type='email'
            value={email}
            onChange={(e) => {
              setEmail(e.target.value)
            }}
            error={!isValidEmail.valid}
            helperText={isValidEmail.message}
          />
          <InputText
            id='password'
            label='Senha'
            type='password'
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            error={!isValidPassword.valid}
            helperText={isValidPassword.message}
          />
          <Button
            className={classes.submitButton}
            type='submit'
            loading={isLoadingLogin}
          >
            Entrar
          </Button>
          <Link to={routes.PasswordRecovery()}>
            <Typography variant='body2'>Esqueci minha senha</Typography>
          </Link>
          <Typography variant={'caption'} className={classes.softwareVersion}>
            Versão {env.softwareVersion}
          </Typography>
        </form>
      </Card>
    </Grid>
  )
}
